import type { ChangeEventHandler } from 'preact/compat';
import { useCallback, useEffect, useRef, useState } from 'preact/hooks';
import './TextInput.less';
import { IconId } from '../icon/icons';
import IconButton from '../button/IconButton';

export type TextInputProps = {
    value: string;
    onChange: ChangeEventHandler<HTMLTextAreaElement>;
    onKeyDown: (event: KeyboardEvent) => void;
    placeholder?: string;
    maxLength?: number;
    disabled?: boolean;
    endIconId?: IconId;
    endIconTitle?: string;
    onClickEndIcon?: () => void;
};

const TextInput = ({
    value,
    onChange,
    onKeyDown,
    placeholder,
    maxLength,
    disabled,
    endIconId,
    endIconTitle,
    onClickEndIcon
}: TextInputProps) => {
    const textareaRef = useRef<HTMLTextAreaElement>(null);
    const [isInputFocused, setInputFocused] = useState(false);
    useEffect(() => {
        if (!value && textareaRef.current) {
            textareaRef.current.focus();
        }
    }, [value]);
    const onInputFocus = useCallback(() => {
        setInputFocused(true);
    }, []);
    const onInputBlur = () => {
        setInputFocused(false);
    };
    return (
        <div className={`bri-TextInput ${isInputFocused ? 'bri-focused' : ''}`}>
            <div
                className="bri-TextInput-textarea-grow-wrap bri-SlimScroll"
                data-replicated-value={value}
            >
                <textarea
                    disabled={disabled}
                    ref={textareaRef}
                    placeholder={placeholder}
                    autoFocus
                    value={value}
                    onInput={onChange}
                    onKeyDown={onKeyDown}
                    maxLength={maxLength}
                    spellcheck={true}
                    onFocus={onInputFocus}
                    onBlur={onInputBlur}
                    rows={1}
                    className={'bri-DisplayFont'}
                />
            </div>
            {endIconId && (
                <IconButton
                    variant="primary"
                    className="bri-TextInput-end-icon bri-ZoomIn"
                    iconId={endIconId}
                    title={endIconTitle}
                    onClick={onClickEndIcon}
                    disabled={disabled}
                />
            )}
        </div>
    );
};

export default TextInput;
